import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Check",
  "use": "Check-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" id=\"Check\">\n  <path fill=\"currentColor\" d=\"M6 11.17L1.83 7 .41 8.41 6 14 18 2 16.59.59z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol